export function extractShopifyId(gid: string) {
  return gid.replace(/^gid:\/\/[^/]+\/[^/]+\/(.+)$/, '$1')
}
